const invalidTokenCodeArr = [
  'INVALID_TOKEN_STATUS', 'EXPIRED_TOKEN_STATUS', 'FORCED_LOGOUT_STATUS',
  'INVALID_DATA'];

export { invalidTokenCodeArr };
